<template>
  <div class="flex flex-row border-b-4 border-orange items-center">
    <app-year-selector color="orange">
      <template v-slot:icon>
        <timeline-icn
          :class="['ml-3 mr-3 orange-icon']"
          width="20px"
          height="20px"
        ></timeline-icn>
      </template>
    </app-year-selector>
    <app-month-selector v-if="isCalendarView"> </app-month-selector>
    <app-search-input class="top-1" color="orange" v-else></app-search-input>
    <Popover
      class="relative"
      v-bind="$attrs"
      style="margin-bottom: -8px; margin-left: 4px;"
    >
      <PopoverButton
        class="filter-select relative border-4 border-b-0 h-10 w-full py-2 pl-2 pr-8 text-left bg-white cursor-pointer border-orange"
      >
        <!-- <span class="block truncate text-orange">すべてを表示</span> -->
        <div
          class="flex flex-row items-center justify-center"
          v-if="isCalendarView"
        >
          <CalendarIcn width="20px" height="20px" class="orange-icon mr-1" />
          <span class="block truncate text-orange text-small">カレンダー</span>
        </div>
        <div class="flex flex-row items-center justify-center" v-else>
          <TimelineIcn width="20px" height="20px" class="orange-icon mr-1" />
          <span class="block truncate text-orange text-small"
            >タイムライン</span
          >
        </div>
        <span
          class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none"
        >
          <chevron-icn
            width="20px"
            height="20px"
            class="orange-icon"
          ></chevron-icn>
        </span>
      </PopoverButton>
      <transition
        enter-active-class="transition duration-200 ease-out"
        enter-from-class="translate-y-1 opacity-0"
        enter-to-class="translate-y-0 opacity-100"
        leave-active-class="transition duration-150 ease-in"
        leave-from-class="translate-y-0 opacity-100"
        leave-to-class="translate-y-1 opacity-0"
      >
        <PopoverPanel
          v-slot="{ close }"
          class="absolute w-full border-4 z-40 bg-white px-4 py-4 border-orange"
        >
          <button
            @click="
              () => {
                useCalendarView(false)
                close()
              }
            "
          >
            <div class="flex flex-row items-center justify-center">
              <TimelineIcn
                width="20px"
                height="20px"
                class="orange-icon mr-1"
              />
              <span class="text-orange text-small">タイムライン</span>
            </div>
          </button>
          <button
            @click="
              () => {
                useCalendarView(true)
                close()
              }
            "
          >
            <div class="flex flex-row items-center justify-center">
              <CalendarIcn
                width="20px"
                height="20px"
                class="orange-icon mr-1"
              />
              <span class="text-orange text-small">カレンダー</span>
            </div>
          </button>
        </PopoverPanel>
      </transition>
    </Popover>
    <!-- <div class="w-full"></div> -->
    <!-- <div class="w-96 text-right">
      <span class="font-bold font-large text-yellow mr-3">総額</span>
      <span class="font-bold font-large text-yellow">9,990,000 円</span>
    </div> -->
  </div>
</template>
<script>
import AppYearSelector from '@/components/ui/AppYearSelector'
import AppMonthSelector from '@/components/ui/AppMonthSelector'

import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue'

import ChevronIcn from '@/assets/icons/chevron.svg?inline'
import CalendarIcn from '@/assets/icons/calendar.svg?inline'
import TimelineIcn from '@/assets/icons/timeline.svg?inline'
import AppSearchInput from '@/components/ui/AppSearchInput'

import { useLogs } from '@/services/useLogs'

export default {
  name: 'LogsHeader',

  components: {
    AppYearSelector,
    AppMonthSelector,
    TimelineIcn,
    Popover,
    PopoverButton,
    PopoverPanel,
    ChevronIcn,
    CalendarIcn,
    AppSearchInput,
  },

  setup() {
    return { ...useLogs() }
  },
}
</script>
<style lang="scss" scoped>
.filter-select {
  box-sizing: border-box;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  width: 164px;
}

#headlessui-popover-panel-4 {
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}
</style>
